export default __webpack_public_path__ + "d94e0cd9ecf3f8b5b1d1e5fd4454c61d.png";